"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ExpressDealBadge: ()=>ExpressDealBadge_ExpressDealBadge,
    default: ()=>ExpressDealBadge
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const BadgeWrapper = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Badge).withConfig({
    displayName: "ExpressDealBadge__BadgeWrapper"
})([
    "position:absolute;top:12px;left:12px;"
]);
const RelativeBox = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "ExpressDealBadge__RelativeBox"
})([
    "position:relative;"
]);
const ExpressDealBadge_ExpressDealBadge = ()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RelativeBox, {
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(BadgeWrapper, {
            bg: "background.lightest",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Image, {
                height: 12,
                src: "https://s1.pclncdn.com/design-assets/brand-assets/express-deal-logo-tm.svg"
            })
        })
    });
const ExpressDealBadge = ExpressDealBadge_ExpressDealBadge;
exports.ExpressDealBadge = __webpack_exports__.ExpressDealBadge;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ExpressDealBadge",
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
